<template>
  <span>
    <transition-group
      enter-to-class="animate__animated animate__flipInY"
      leave-class="d-none"
    >
      <div
        class="ban card card-custom gutter-b"
        style="min-height: 410px;"
        v-for="(mod, i) in modules"
        v-show="i === index"
        :key="mod.id"
      >
        <div :class="'card-body d-flex p-0 welcome ' + statusClass(mod)">
          <div
            class="flex-grow-1 p-20 pb-40 card-rounded flex-grow-1 bgi-no-repeat text-left bg-card-image"
            :style="
              'background-image: url(' +
                require(`@/assets/images/humans/${mod.image}`) +
                ')'
            "
          >
            <h2 :class="'pb-5 font-weight-bolder ' + statusClass(mod, false)">
              {{ $t(`messages.dashboard.status.${mod.id}`) }}
            </h2>
            <p :class="'pb-5 font-size-h5 ' + statusClass(mod, false)">
              {{ textContent(mod) }}
            </p>
            <b-button
              tag="a"
              class="font-weight-bolder py-2 px-6"
              variant="dark"
              @click="$router.push({ name: 'Departments' })"
              >{{
                $t(`messages.dashboard.dynamic.congratulations.cta`)
              }}</b-button
            >
          </div>
        </div>
      </div>
    </transition-group>
  </span>
</template>

<script>
import { getClassByValueAndBase } from "@/utils/helpers";

export default {
  name: "SlideStatusCard",
  props: {
    modules: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      index: 0
    };
  },
  methods: {
    statusClass(mod, background = true) {
      return getClassByValueAndBase(
        mod.score,
        mod.base || 10,
        true,
        background
      );
    },
    textContent(mod) {
      var level = 1;
      var score = mod.base ? mod.score / (mod.base / 10) : mod.score;
      if (score < 5) level = 1;
      else if (score < 7) level = 2;
      else if (score < 9) level = 3;
      else level = 4;
      return this.$t(`messages.dashboard.levels.level${level}`, {
        module: this.$t(`messages.dashboard.status.${mod.id}`).toLowerCase()
      });
    }
  },
  mounted: function() {
    var app = this;
    setInterval(function() {
      if (app.index + 1 === app.modules.length) app.index = 0;
      else app.index++;
    }, 6000);
  }
};
</script>

<style lang="scss" scoped>
.bg-card-image {
  background-position: calc(100% + 0.5rem) bottom;
  background-size: 80% auto;
}
.bg-success {
  .bg-card-image {
    background-size: 70% auto;
    p {
      padding-right: 1.2rem;
    }
  }
}
.bg-default {
  background-color: #1b283f;
  .bg-card-image {
    color: white;
  }
}
.card-body.d-flex {
  border-radius: 0.42rem;
}
.btn.btn-black {
  background-color: #1a1947;
  border-color: #1a1947;
  color: white;
}
.welcome.bg-success .bg-card-image {
  background-size: 120% auto;
}
</style>
